import { tableStyles } from 'css/tableStyles';
import React, { useMemo } from 'react';
import DataTable from 'components/DataTable';
import { Loading } from 'components/loading/Loading';
import { DATE_FORMATS, formatDate } from 'utils';
import styles from './index.module.scss';

const SyncHistory = ({ loading, syncHistory = [] }) => {

  const columns = useMemo(
    () => [
      {
        name: 'S.No.',
        sortable: false,
        width: '180px',
        cell: (row, index) => index + 1,
      },
      {
        name: 'Sync Performed At',
        sortable: true,
        width: '350px',
        cell: row => <div>
          {row.syncPerformedAt?.iso ? formatDate(row.syncPerformedAt?.iso, DATE_FORMATS.MM_DD_YYYY_hh_mm_A) : '-'}
        </div>,
      },
      {
        name: 'Error',
        sortable: false,
        selector: 'error',
        cell: (row) => row?.error || '-',
      },
    ],
    [],
  );

  return (
    <div className={styles['sync-history-container']}>
      {loading && <Loading type={'mini'} />}
      <div className={styles['heading']}>Sync History</div>
      <DataTable
        columns={columns}
        noHeader={true}
        data={syncHistory}
        highlightOnHover={true}
        defaultSortField="syncPerformedAt"
        customStyles={tableStyles}
        loading={loading}
      />
    </div>
  );
};

export default SyncHistory;
